import { render, staticRenderFns } from "./AutoComplete.vue?vue&type=template&id=48933f53&scoped=true&"
import script from "./AutoComplete.vue?vue&type=script&lang=js&"
export * from "./AutoComplete.vue?vue&type=script&lang=js&"
import style0 from "./AutoComplete.vue?vue&type=style&index=0&id=48933f53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../BuildingCatalog/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48933f53",
  null
  
)

/* custom blocks */
import block0 from "./AutoComplete.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports